import {
  DepositPromo,
  DepositPromoId,
  DepositSettings,
} from '../../state/deposit/deposit.types';
import { DepositPromos } from './Promos/Promos.types';
import { getPromoLocked } from './Promos/Promos.utils';

const isDepositPromo = ({ promoType, subPromoType, status }: DepositPromo) =>
  promoType === 'Action' && subPromoType === 'Deposit' && status !== 'Locked';

export const parseDepositPromos = (
  promos?: DepositPromo[],
  depositCount?: number,
) => {
  if (!promos) {
    return;
  }

  const ids: Array<DepositPromo['promotionId']> = [];
  const byId: Record<DepositPromo['promotionId'], DepositPromo> = {};

  promos.forEach((promo) => {
    const { promotionId, promoType } = promo;

    if (
      (promoType === 'Welcome' && depositCount === 0) ||
      isDepositPromo(promo)
    ) {
      ids.push(promotionId);
      byId[promotionId] = promo;
    }
  });

  return { ids, byId };
};

export const getPromoQualificationAmount = (promos: DepositPromo[]) =>
  promos.find(
    ({ promoType, isOptedIn }) =>
      (promoType === 'Action' || promoType === 'Welcome') && isOptedIn,
  )?.subTypeMeta?.minimumQualificationAmount;

export const getDefaultAmount = (
  settings?: DepositSettings,
  selectedAmount?: number,
) =>
  settings?.availableAmounts.some(({ amount }) => amount === selectedAmount)
    ? selectedAmount
    : settings?.availableAmounts[0].amount;

export const getDefaultPromos = (promos: DepositPromo[]) =>
  promos.reduce(
    (accumulator: DepositPromoId[], promo) =>
      promo.isOptedIn && isDepositPromo(promo)
        ? [...accumulator, promo.promotionId]
        : accumulator,
    [],
  );

export const getAvailablePromos = (
  selectedIds: DepositPromoId[],
  promos?: DepositPromos,
  selectedAmount?: number,
) =>
  promos
    ? promos.ids.reduce((accumulator: DepositPromoId[], promoId) => {
        const promo = promos.byId[promoId];
        const { isOptedIn, promoType } = promo;
        const isWelcome = promoType === 'Welcome';
        const locked = getPromoLocked(promo, selectedAmount);

        return ((isOptedIn && isWelcome) || selectedIds.includes(promoId)) &&
          !locked
          ? [...accumulator, promoId]
          : accumulator;
      }, [])
    : [];

export const findNonWelcomePromoId = (
  promoIds: DepositPromoId[],
  promos?: DepositPromos,
) => promoIds.find((promoId) => promos?.byId[promoId].promoType !== 'Welcome');

export const findOptedInPromoId = (promos?: DepositPromos) =>
  promos?.ids.find(
    (promoId) => 
      promos?.byId[promoId].isOptedIn
      && promos?.byId[promoId].promoType !== "Welcome");
